import { call, put, takeEvery } from "redux-saga/effects";

import { ResponseGenerator } from "../../interfaces";
import { GET_TEMPLATES, GetTemplatesAction } from "./actionTypes";
import { getTemplates } from "../../helpers/backend_helper";
import { getTemplatesError, getTemplatesSuccess } from "./actions";

function* getTemplatesSaga({}: GetTemplatesAction) {
  try {
    const response: ResponseGenerator = yield call(getTemplates);
    yield put(getTemplatesSuccess(response.data));
  } catch (error) {
    yield put(getTemplatesError(error));
  }
}
function* TemplateSaga() {
  yield takeEvery(GET_TEMPLATES, getTemplatesSaga);
}

export default TemplateSaga;
